import { SubscriptionPlatform } from "@next-platform/packages-ts-types";
import { SubscriptionStatus, UserRoles } from "../../types";
import { PLAN_STATE, SUBSCRIPTION_MANAGE_DESTINATION } from "../constants/subscriptionPlan";
const MS_PER_DAY = 86_400_000;
const PROGRESS_PERCENT_MAX = 100;
export const formatSubscriptionDate = (timestamp) => {
    if (timestamp === null || timestamp === undefined) {
        return "";
    }
    const parsedTimestamp = typeof timestamp === "number" ? timestamp : Number(timestamp);
    if (!Number.isFinite(parsedTimestamp) || parsedTimestamp <= 0) {
        return "";
    }
    return new Date(parsedTimestamp).toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
        timeZone: "UTC",
    });
};
export const getDaysRemaining = (expireOn) => {
    if (!expireOn) {
        return 0;
    }
    const remainingMilliseconds = expireOn - Date.now();
    if (remainingMilliseconds <= 0) {
        return 0;
    }
    return Math.ceil(remainingMilliseconds / MS_PER_DAY);
};
export const getPlanDurationDays = ({ startDate, expireOn }) => {
    if (!startDate || !expireOn || expireOn <= startDate) {
        return 0;
    }
    return Math.ceil((expireOn - startDate) / MS_PER_DAY);
};
export const getProgressPercent = ({ daysRemaining, totalPlanDays }) => {
    if (totalPlanDays <= 0) {
        return 0;
    }
    const daysConsumed = totalPlanDays - daysRemaining;
    return Math.min(PROGRESS_PERCENT_MAX, Math.max(0, (daysConsumed / totalPlanDays) * PROGRESS_PERCENT_MAX));
};
export const resolveIsOneTimeExpired = ({ subscription, isOneTime, daysRemaining }) => {
    if (!isOneTime) {
        return false;
    }
    if (subscription?.expire_on) {
        return daysRemaining <= 0;
    }
    return subscription?.status === SubscriptionStatus.EXPIRED;
};
export const resolvePlanState = ({ subscription, isOneTime, isOneTimeExpired }) => {
    if (subscription?.status === SubscriptionStatus.GRACE) {
        return PLAN_STATE.GRACE;
    }
    if (subscription?.status === SubscriptionStatus.PAUSED) {
        return PLAN_STATE.PAUSED;
    }
    if (subscription?.status === SubscriptionStatus.CANCELLED) {
        return PLAN_STATE.CANCELLED;
    }
    if (subscription?.status === SubscriptionStatus.EXPIRED || isOneTimeExpired) {
        return PLAN_STATE.EXPIRED;
    }
    if (!subscription?.role) {
        return PLAN_STATE.FREE;
    }
    if (isOneTime) {
        return PLAN_STATE.ONE_TIME_ACTIVE;
    }
    return PLAN_STATE.RECURRING_ACTIVE;
};
export const isPremiumPlanState = (planState) => planState !== PLAN_STATE.EXPIRED && planState !== PLAN_STATE.FREE;
export const resolvePlanRole = (role) => role ?? UserRoles.FREE;
export const resolveDisplayPlanRole = ({ planState, planRole, subscriptionRole }) => planState === PLAN_STATE.EXPIRED && subscriptionRole !== UserRoles.FREE ? subscriptionRole : planRole;
export const resolveManageDestination = ({ isOneTimeManageable, platform }) => {
    if (isOneTimeManageable) {
        return SUBSCRIPTION_MANAGE_DESTINATION.OVERVIEW;
    }
    switch (platform) {
        case SubscriptionPlatform.REVENUE_CAT:
            return SUBSCRIPTION_MANAGE_DESTINATION.SUBSCRIBE;
        case SubscriptionPlatform.STICKY:
            return SUBSCRIPTION_MANAGE_DESTINATION.PORTAL;
        case SubscriptionPlatform.BOOSTY:
            return SUBSCRIPTION_MANAGE_DESTINATION.CHECKOUT;
        case SubscriptionPlatform.SUBSCRIBE_STAR:
            return SUBSCRIPTION_MANAGE_DESTINATION.SUBSCRIBE_STAR;
        default:
            return SUBSCRIPTION_MANAGE_DESTINATION.NONE;
    }
};
